import { Injectable } from '@angular/core';
import { LocalStorageService } from './localstorage.service';
import { ActionModel } from '../models/actionmodel';
import { DataService } from './data.service';
import { HttpRequestOptions, HttpResponse, HttpStatus } from '../models/http';
import { AuthorityAction } from '../models/authorityaction.enum';
import { TrackAuthority } from '../models/trackauthority';
import { EventBusService, EventType, ATMEventData } from "./eventbus.service";

@Injectable()
export class DataSyncService {

    private totalActionsPending: number = 0;

    constructor(private dataService: DataService, private localstorage: LocalStorageService, private eventBus: EventBusService) { }

    performCachedActions(): Promise<void> {
        return new Promise<void>((resolve: Function, reject: Function) => {
            this.localstorage.getAllOfflineActions().then((actionModels: ActionModel[]) => {

                this.totalActionsPending = actionModels.length;
                if (this.totalActionsPending === 0) {
                    resolve();
                }
                actionModels.sort((object1: ActionModel, object2: ActionModel) => object2.id - object1.id);
                actionModels.forEach((actionModel: ActionModel) => {

                    let options: HttpRequestOptions = JSON.parse(actionModel.options) as HttpRequestOptions;
                    options.successMessageOverride = n => this.prepareSuccessMessage(actionModel.authorityAction, actionModel.trackAuthority);
                    if (actionModel.numberOfRetry === 0) {
                        options.errorMessageOverride = n => this.prepareErrorMessage(actionModel.authorityAction, actionModel.trackAuthority);
                    } else {
                        options.errorMessageOverride = n => null;
                    }

                    this.dataService.sendRequest(options)
                        .then(() => this.dequeueAction(actionModel, resolve))
                        .catch((error: HttpResponse) => {
                            if (error.statusCode !== 500 || actionModel.numberOfRetry <= 0) {
                                if (actionModel.numberOfRetry > 0) {
                                    this.eventBus.fireEvent(EventType.NOTIFY_FAILURE_EVENT, new ATMEventData(null, () => this.prepareErrorMessage(actionModel.authorityAction, actionModel.trackAuthority)));
                                }
                                this.dequeueAction(actionModel, resolve);
                            } else {
                                this.localstorage.updateRetryCount(actionModel, actionModel.numberOfRetry - 1).then(() => this.updatePendingSyncsAndResolve(resolve));
                            }
                        });
                });
            });
        });
    }

    private dequeueAction(actionModel: ActionModel, resolve: Function): void {
        this.localstorage.dequeueOfflineAction(actionModel).then(() => this.updatePendingSyncsAndResolve(resolve)).catch(() => this.updatePendingSyncsAndResolve(resolve));
    }

    private updatePendingSyncsAndResolve(resolve: Function): void {
        this.totalActionsPending--;
        if (this.totalActionsPending === 0) {
            resolve();
        }
    }

    private prepareErrorMessage(authorityAction: AuthorityAction, trackAuthority: TrackAuthority): string {
        switch (authorityAction) {
            case AuthorityAction.TRANSFER_TO_PAPER:
                return "Request to 'Transfer To Paper' could not be completed for EC1: #" + trackAuthority.ec1Number + "; Please Retry!";
            default:
                return "";
        }
    }

    private prepareSuccessMessage(authorityAction: AuthorityAction, trackAuthority: TrackAuthority): string {
        switch (authorityAction) {
            case AuthorityAction.TRANSFER_TO_PAPER:
                return "Request to 'Transfer To Paper' completed for EC1: #" + trackAuthority.ec1Number;
            default:
                return "";
        }
    }
}